var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/shopping-cart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 2.65137H3.74001C4.82001 2.65137 5.67 3.58137 5.58 4.65137L4.75 14.6114C4.61 16.2414 5.89999 17.6414 7.53999 17.6414H18.19C19.63 17.6414 20.89 16.4614 21 15.0314L21.54 7.53137C21.66 5.87137 20.4 4.52136 18.73 4.52136H5.82001",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.25 22.6514C16.9404 22.6514 17.5 22.0917 17.5 21.4014C17.5 20.711 16.9404 20.1514 16.25 20.1514C15.5596 20.1514 15 20.711 15 21.4014C15 22.0917 15.5596 22.6514 16.25 22.6514Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.25 22.6514C8.94036 22.6514 9.5 22.0917 9.5 21.4014C9.5 20.711 8.94036 20.1514 8.25 20.1514C7.55964 20.1514 7 20.711 7 21.4014C7 22.0917 7.55964 22.6514 8.25 22.6514Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9 8.65137H21",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.2ce2d34698cca03f1634ca1d99134c37.svg";
export { ForwardRef as ReactComponent };